import { Model } from ".";

export default class PricingHelp extends Model {
	get singularNoun() {
		return "pricing help";
	}

	get pluralNoun() {
		return "pricing help list";
	}

	resource() {
		return "pricing";
	}
}
